"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var assets_exports = {};
__export(assets_exports, {
  box: () => box,
  checkBox: () => checkBox
});
module.exports = __toCommonJS(assets_exports);
var checkBox = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iLTAuMDAwNDg4MjgxIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHJ4PSI0IiBmaWxsPSIjNDA3MTc3Ii8+CjxwYXRoIGQ9Ik02LjEzMzYzIDEyLjAwMjdMNCAxNC4xNTU4TDkuNjgyNzIgMTguOTk5NUwyMCA3LjkwMDc2TDE3LjYwNDIgNS45OTk1MUw5LjQxMDk1IDE0Ljc5NjFMNi4xMzM2MyAxMi4wMDI3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
var box = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMC45OTk1MTIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjQiIHN0cm9rZT0iIzcwNkM1QyIvPgo8L3N2Zz4K";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  box,
  checkBox
});
//# sourceMappingURL=assets.js.map